<template>
  <section>
    <b-list-group>
      <b-list-group-item
        class="d-flex justify-content-between align-items-center"
        v-for="file in files"
        :key="file.name"
        :href="file.url"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ file.name }}
        <b-icon icon="cloud-download" variant="primary" font-scale="2"></b-icon>
      </b-list-group-item>
    </b-list-group>
  </section>
</template>

<script>
import Vue from 'vue'

import { IconsPlugin } from 'bootstrap-vue'
import { ListGroupPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(IconsPlugin)
Vue.use(ListGroupPlugin)

export default {
  i18n,
  name: 'downloadable-file-list',
  props: {
    files: {
      type: Array,
      required: true,
    }
  },
}
</script>